'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.linkedEmailListWidget = function (subscriptionModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			linkedEmailTemplate = widget.find('[data-mm-role~="linkedEmailTemplate"]').remove(),
			applyGoldAccountInfo = function (goldAccountInfo) {
				const authenticatedEmail = goldAccountInfo && goldAccountInfo.license && goldAccountInfo.license.email,
					linkedEmails = (goldAccountInfo && goldAccountInfo.subscription && goldAccountInfo.subscription.linkedEmails) || [];
				widget.empty();
				linkedEmails.forEach(function (linkedEmail) {
					let linkedEmailDescription = linkedEmail;
					const linked = linkedEmailTemplate.clone(),
						removeButton = linked.find('[data-mm-role~="remove-linked-email"]');
					if (linkedEmail === authenticatedEmail) {
						widget.prepend(linked);
						removeButton.addClass('disabled');
						linkedEmailDescription += ' (authenticated)';
					} else {
						widget.append(linked);
						removeButton.click(function () {
							subscriptionModel.removeLinkedEmail(linkedEmail);
						}).removeClass('disabled');
					}
					linked.find('[data-mm-role~="linkedEmail"]').text(linkedEmailDescription);

				});
			};
		subscriptionModel.addEventListener('goldAccountInfo', applyGoldAccountInfo);
	});

};
